const preType = 'APPOINTMENT_';

export const AppointmentActionTypes = {
  SET_SELECTED_ADDRESS: `${preType}SET_SELECTED_ADDRESS`,
  SET_DATE_PICKER: `${preType}SET_DATE_PICKER`,
  SET_APPOINTMENT_DATE: `${preType}SET_APPOINTMENT_DATE`,
  GET_SERVICE_FEE: `${preType}GET_SERVICE_FEE`,
  SET_SERVICE_FEE: `${preType}SET_SERVICE_FEE`,
  SET_USER_DATA: `${preType}SET_USER_DATA`,
  SET_SELECTED_SERVICE: `${preType}SET_SELECTED_SERVICE`,
  SET_EXPAND_ADDRESS: `${preType}SET_EXPAND_ADDRESS`,
  GET_APPOINTMENT_TIMESHEET: `${preType}GET_APPOINTMENT_TIMESHEET`,
  SET_APPOINTMENT_TIMESHEET: `${preType}SET_APPOINTMENT_TIMESHEET`,
  SET_SELECTED_TIME: `${preType}SET_SELECTED_TIME`,
  STORE_SERVICE_REQUEST: `${preType}STORE_SERVICE_REQUEST`,
  SET_ADDRESS_MODAL: `${preType}SET_ADDRESS_MODAL`,
  SET_TIMESHEET_LOADING: `${preType}SET_TIMESHEET_LOADING`,
};

const setSelectedAddress = (data: { addressKey: string }) => ({ type: AppointmentActionTypes.SET_SELECTED_ADDRESS, data: data });
const setDatePicker = (data: { switchToDatePicker: boolean }) => ({ type: AppointmentActionTypes.SET_DATE_PICKER, data: data });
const getUserServiceFee = (data: { addressKey: string }) => ({ type: AppointmentActionTypes.GET_SERVICE_FEE, data: data });
const setUserData = (data: { userId: string, selectedServiceTypeId: string }) => ({ type: AppointmentActionTypes.SET_USER_DATA, data: data });
const setSelectedService = (data: { selectedServiceFee: object }) => ({ type: AppointmentActionTypes.SET_SELECTED_SERVICE, data: data });
const setExpandAddress = (data: { expandUserAddress: string | boolean }) => ({ type: AppointmentActionTypes.SET_EXPAND_ADDRESS, data: data });
const getTimeSheet = (data: { selectedDate: string }) => ({ type: AppointmentActionTypes.GET_APPOINTMENT_TIMESHEET, data: data });
const setSelectedTime = (data: { selectedTime: string }) => ({ type: AppointmentActionTypes.SET_SELECTED_TIME, data: data });
const storeServiceRequest = () => ({ type: AppointmentActionTypes.STORE_SERVICE_REQUEST });
const returnToAddress = () => ({ type: AppointmentActionTypes.SET_ADDRESS_MODAL });

export const AppointmentActions = {
  setSelectedAddress: setSelectedAddress,
  setDatePicker: setDatePicker,
  getUserServiceFee: getUserServiceFee,
  setUserData: setUserData,
  setSelectedService: setSelectedService,
  setExpandAddress: setExpandAddress,
  getTimeSheet: getTimeSheet,
  setSelectedTime: setSelectedTime,
  storeServiceRequest: storeServiceRequest,
  returnToAddress: returnToAddress,
};
